import React from 'react';
import PropTypes from 'prop-types';
import {
  MAP_PIN_PRIMARY_HEIGHT_PX,
  MAP_PIN_PRIMARY_WIDTH_PX,
} from '../../../../modules/theme/map';
import shadeColor from '../../../lib/shadeColor';

const innerFill = '#fcfc5e';
const strokeColor = '#ead900';

const propTypes = {
  // color: PropTypes.string.isRequired,
  id: PropTypes.string.isRequired,
  onClick: PropTypes.func,
};

const FacilityPin = ({
  id,
  onClick,
  style,
  text,
  textColor,
  active,
  ...rest
}) => {
  const svgStyle = {
    height: `${MAP_PIN_PRIMARY_HEIGHT_PX}px`,
    width: `${MAP_PIN_PRIMARY_WIDTH_PX}px`,
    ...style,
  };

  const strokeFill = active ? shadeColor(strokeColor) : strokeColor;
  return (
    <svg
      {...rest}
      role="img"
      xmlns="http://www.w3.org/2000/svg"
      data-testid="map-pin-primary"
      onClick={onClick}
      style={svgStyle}
      viewBox="0 0 31 30"
    >
      <polygon
        fill={innerFill}
        points="19.94 10.27 29.9 11.63 22.77 18.82 24.58 28.84 15.63 24.2 6.79 29.04 8.38 18.98 1.11 11.94 11.04 10.37 15.39 1.18 19.94 10.27"
      />
      <path
        d="M6.11,30,7.83,19.16,0,11.59l10.69-1.7L15.38,0l4.89,9.79L31,11.25,23.33,19l1.94,10.79-9.63-5ZM2.22,12.29l6.71,6.5L7.46,28.08l8.17-4.47,8.26,4.29-1.67-9.26L28.79,12,19.6,10.75,15.4,2.36l-4,8.48Z"
        data-testid="map-pin-primary-stroke"
        fill={strokeFill}
      />
    </svg>
  );
};

propTypes.propTypes = propTypes;

export default FacilityPin;
